"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Tree = _interopRequireDefault(require("./Tree"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Tree["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/tree/index.js
// module id = 943
// module chunks = 1